/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

// Highlight last word of hero title
document.querySelectorAll('.hero-slide .callout__content .base__title p').forEach(p => {
  const words = p.textContent.trim().split(' ');
  const lastWord = words.pop();

  p.innerHTML = `${words.join(' ')} <span class="hero-title-last-word">${lastWord}</span>`;
});
